import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private BE_URL = '';
  account: any;

  private profilePictures: any = {};

  constructor(
    private httpClient: HttpClient,
  ) {
    this.BE_URL = environment.API_URL;
  }

  getDashboardData() {
    const url = this.BE_URL + '/planner';
    return this.httpClient.get(url);
  }

  // getAccountImage(url: string) {
  //   return this.httpClient
  //     .get(url, { responseType: 'blob' })
  //     .pipe(switchMap((blob) => blobToBase64(blob)));
  // }

  getUserImageByUserId(id: string) {
    const url = this.BE_URL + '/planner/photo/' + id;
    return this.httpClient.get(url);
  }

  postProjectLead(data: ProjectLeadRequest) {
    const url = this.BE_URL + '/planner/project-lead';
    return this.httpClient.post(url, data);
  }

  postBgImage(bgUrl: string) {
    const url = this.BE_URL + '/background';
    return this.httpClient.post(url, {
      name: `BG_${Date.now()}`,
      display_url: bgUrl,
    });
  }

  getBgImage() {
    const url = this.BE_URL + '/background';
    return this.httpClient.get(url);
  }

  setCacheImage(id: string, base64: string) {
    this.profilePictures[id] = base64;
  }

  getCacheImage(id: string) {
    return this.profilePictures[id];
  }
}

export interface ProjectLeadRequest {
  projectLeadName: string;
  projectLeadTitle: string;
  projectId: string;
}
